import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';
import AppActions from '~/actions/app';
import NotFound from '~/components/NotFound';

export default function Boundary({ className = '', children }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleReset = () => {
        dispatch(AppActions.logoutRequest());
        navigate('/hcm');
    };

    const logError = (error, errorInfo) => {
        // Log errors in development for debugging
        if (import.meta.env.DEV) {
            console.error('ErrorBoundary caught an error:', error);
            if (errorInfo?.componentStack) {
                console.error('Component stack:', errorInfo.componentStack);
            }
        }
    };

    return (
        <ErrorBoundary fallbackRender={({ resetErrorBoundary }) => <NotFound reset={resetErrorBoundary} />} onError={logError} onReset={handleReset}>
            {className ? <div className={className}>{children}</div> : children}
        </ErrorBoundary>
    );
}
